export default {
  title: 'Projects',
  titleButton: 'New project',
  titleButtonShort: 'New',
  cards: {
    actions: {
      edit: 'Edit project name',
      share: 'Share',
      delete: 'Delete project'
    },
    footer: {
      itemsCount: '{count} items'
    },
    noAccessTooltip: "You don't have access to edit this {type}",
    noPermissionsTooltip: "You don't have permissions to edit this {type}",
    folderIcon: 'Project folder'
  },
  listView: {
    columns: {
      projectName: 'Project Name',
      owner: 'Owner',
      lastUpdate: 'Last update'
    },
    tooltips: {
      anyoneInOrganization: 'Project: Anyone in {orgName} has access',
      project: 'Project'
    }
  },
  contentListView: {
    columns: {
      name: 'Name',
      owner: 'Owner',
      tags: 'Tags',
      lastUpdate: 'Last update'
    },
    actionsMenu: 'Actions for {name}',
    tooltips: {
      folder: 'Folder',
      folderOrg: 'Folder: Anyone in {orgName} has access',
      mapOrg: 'Map: Anyone in {orgName} has access',
      mapRestricted: 'Map: Only invited people have access',
      workflowOrg: 'Workflow: Anyone in {orgName} has access',
      workflowRestricted: 'Workflow: Only invited people have access',
      shortcutMap: 'Map shortcut',
      shortcutWorkflow: 'Workflow shortcut',
      shortcutPrivate: "You don't have access to this shortcut"
    }
  },
  emptyState: {
    noProjectsCreated: "You haven't created any projects yet",
    button: 'Create your first project',
    noProjectsBeenShared: 'No projects have been shared with you yet.'
  },
  createDialog: {
    ariaLabel: 'Create project form dialog',
    title: 'Create new project',
    createButton: 'Create project',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Project created successfully'
  },
  createFolderDialog: {
    ariaLabel: 'Create folder form dialog',
    title: 'New folder',
    createButton: 'Create folder',
    fields: {
      title: 'Folder name',
      titlePlaceholder: 'Type the folder name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Folder created successfully'
  },
  filters: {
    search: 'Search project',
    searchInCurrentLevel: 'Search by name in current level',
    searchResults: '{elements} results by "{query}"',
    noResults: 'No projects were found',
    noAssetsResults: 'No assets were found',
    noResultsFolders: 'No folders were found',
    noResultsMaps: 'No maps were found',
    noResultsWorkflows: 'No workflows were found',
    noResultsTags: 'No assets were found',
    noResultsInLevel: 'No results were found in this level',
    total: `{itemCount} {itemCount, plural,
      one {project}
      other {projects}
    }`,
    owner: {
      all: 'Owned by anyone',
      mine: 'Owned by me',
      others: 'Owned by others'
    },
    type: {
      all: 'All types',
      folders: 'Folders',
      maps: 'Maps',
      workflows: 'Workflows'
    },
    order: {
      sortLabel: 'Sort',
      sortByHeader: 'Sort by',
      updatedAt: 'Last updated',
      title: 'A-Z'
    },
    folderGrouping: {
      header: 'Folders',
      onTop: 'On top',
      mixed: 'Mixed with files'
    }
  },
  editDialog: {
    ariaLabel: 'Edit project form dialog',
    title: 'Edit project name',
    saveButton: 'Save changes',
    fields: {
      title: 'Project name',
      titlePlaceholder: 'Type the project name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Name changed successfully'
  },
  editFolderDialog: {
    ariaLabel: 'Edit folder form dialog',
    title: 'Edit folder name',
    saveButton: 'Save changes',
    fields: {
      title: 'Folder name',
      titlePlaceholder: 'Type the folder name',
      maxLengthHelper: 'Up to {maxLength} characters allowed'
    },
    success: 'Name changed successfully'
  },
  projectDetails: {
    counter: `{itemCount} {itemCount, plural,
      one {item}
      other {items}
    }`,
    newFolder: 'New folder',
    newAsset: {
      button: 'New asset',
      map: 'Map',
      aiAgent: 'AI Agent',
      workflow: 'Workflow',
      workflowFromTemplate: 'Workflow from template'
    },
    card: {
      ariaLabel: 'Folder card'
    },
    actions: {
      ariaLabel: 'Folder card actions',
      edit: 'Edit folder name',
      editFolder: 'Edit folder name',
      editProject: 'Edit project name',
      share: 'Share',
      moveTo: 'Move to',
      delete: 'Delete folder',
      deleteFolder: 'Delete folder',
      deleteProject: 'Delete project'
    },
    noAccessTooltip: "You don't have access to edit this {type}",
    noPermissionsTooltip: "You don't have permissions to edit this {type}"
  },
  deleteDialog: {
    ariaLabel: 'Delete project form dialog',
    title: 'Delete project',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    info: "Assets inside this project won't be deleted.",
    deleteButton: 'Yes, delete',
    success: 'Project deleted successfully'
  },
  deleteFolderDialog: {
    ariaLabel: 'Delete folder form dialog',
    title: 'Delete folder',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    info: "Assets inside this folder won't be deleted.",
    deleteButton: 'Yes, delete',
    success: 'Folder deleted successfully'
  },
  projectDetailsEmptyState: {
    title: 'This {type} is empty',
    editorDescription: 'Start organizing your maps and workflows in this {type}.',
    editorDescriptionSecondLine: "Or use the 'New folder' button.",
    nonEditorDescription: 'No maps or workflows have been shared with you yet.',
    learnMore: 'Learn more'
  },
  moveFolderDialog: {
    ariaLabel: 'Move folder dialog',
    title: 'Move {type} {name}',
    inheritanceAlert:
      'The {asset} will inherit the sharing permissions from its destination project or folder. Check our <a>documentation</a>.',
    moveButton: 'Move here',
    newProject: 'New project',
    newFolder: 'New folder',
    success: '{type} moved to "{folderName}"',
    moveButtonTooltip: 'This item is already in this folder',
    emptyState: 'This {type} is empty',
    emptyStateProject: 'This project is empty',
    emptyStateFolder: 'This folder is empty',
    assetItselfTooltip: 'This is the {type} you are moving',
    noAccessTooltip: "This {type} isn't shared with you",
    emptyStateNoProjects: {
      caption: "You haven't created any projects yet.",
      description: 'You need to create a project to add the {assetType} shortcut.',
      button: 'Create your first project'
    }
  },
  removeAssetFromContainerDialog: {
    ariaLabel: 'Remove {asset} from {container} dialog',
    title: 'Remove {asset} from {container}',
    description: 'Are you sure you want to remove the {asset} {name} from this {container}?',
    info: 'The {asset} will <strong>not</strong> be deleted, it will only be removed from this {container}. But the {asset} will lose the permissions inherited from the {container}.',
    cancel: 'Cancel',
    confirm: 'Yes, remove',
    success: '{asset, select, map {Map} workflow {Workflow} other {Asset}} removed from {container}'
  },
  folderSelectionHeader: {
    tabs: {
      all: 'All projects',
      mine: 'Owned by me',
      others: 'Owned by others'
    }
  },
  createShortcutDialog: {
    addButtonTooltip: 'This item is already in this folder',
    ariaLabel: 'Create shortcut dialog',
    title: 'Create shortcut of {name}',
    addButton: 'Add here',
    success: 'Shortcut added to "{folderName}"',
    moveButtonTooltip: 'This item is already in this folder',
    tabs: {
      all: 'All projects',
      mine: 'Owned by me',
      others: 'Owned by others'
    },
    newProject: 'New project',
    newFolder: 'New folder',
    emptyState: 'This {type} is empty',
    emptyStateProject: 'This project is empty',
    emptyStateFolder: 'This folder is empty'
  },
  shortcuts: {
    actions: {
      ariaLabel: 'Shortcut card actions',
      deleteShortcut: 'Delete shortcut'
    },
    private: {
      tooltip: "You don't have access to this asset"
    }
  },
  deleteShortcutDialog: {
    ariaLabel: 'Delete shortcut form dialog',
    title: 'Delete shortcut',
    description: 'Are you sure you want to delete {name}?',
    warning: 'This action cannot be undone.',
    deleteButton: 'Yes, delete',
    success: 'Shortcut deleted successfully'
  },
  sharingDialog: {
    footerAlertContent:
      'Lower-level folders will inherit the settings you define for this {assetType}. Check our <a>documentation</a>.',
    alertConfirmationContent:
      'The {assetType} has not yet been shared with other users. If you close the dialog now, the {assetType} will keep the current permissions.',
    restrictedTooltipLabel:
      'This {assetType} is accessible to the entire organization because access is granted through its parent {parentAssetType}.'
  },
  loginPrompt: {
    title: "Oops! You can't access this project",
    content:
      "Use your CARTO credentials or sign up to access this project. If the project exists and is shared with you, you'll be automatically redirected to it.",
    contentEmbedded:
      'Login or sign up using your CARTO credentials in a new window. Then, refresh this page to access the project.'
  }
}
